import React from "react";

const CompIcon = ({ size = 345, h = "10", fill = "#4361E9" }) => {
  // create the height and width based on the size prop, default width is 345 and height is 231
  const width = (size / 345) * 345;
  const height = (size / 345) * 231;
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M19.1759 0H0V19.1759H19.1759V0Z" fill="#4A90E2" />
      <path d="M7.8459 4.3584H4.35938V7.84492H7.8459V4.3584Z" fill="white" />
      <path d="M14.8146 4.3584H11.3281V7.84492H14.8146V4.3584Z" fill="white" />
      <path d="M7.8459 11.3311H4.35938V14.8176H7.8459V11.3311Z" fill="white" />
      <path
        d="M14.8146 11.3311H11.3281V14.8176H14.8146V11.3311Z"
        fill="white"
      />
    </svg>
  );
};

export default CompIcon;
